import { ReactElement } from 'react';
import ImageIcon from '@material-ui/icons/Image';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import { AttachmentType } from '../../../models';
import { NoteAttachmentIcon } from '..';

import './attachment-icon.styles.scss';

export interface IAttachmentIconProps {
	type: AttachmentType;
	color?: string;
	noBackground?: boolean | undefined;
	noPadding?: boolean | undefined;
}

export function AttachmentIcon(props: IAttachmentIconProps): ReactElement {
	const { type, color, noBackground, noPadding } = props;

	switch (type) {
		case AttachmentType.Image:
			return (
				<ImageIcon
					className={`attachment-type-icon ${
						noBackground ? '' : 'add-background'
					} ${noPadding ? 'no-padding' : ''}`}
					style={{ color }}
				/>
			);
		case AttachmentType.Video:
			return (
				<PlayCircleFilledIcon
					className={`attachment-type-icon ${
						noBackground ? '' : 'add-background'
					} ${noPadding ? 'no-padding' : ''}`}
					style={{ color }}
				/>
			);
		case AttachmentType.Note:
			return (
				<NoteAttachmentIcon
					noBackground={noBackground}
					noPadding={noPadding}
					color={color}
					fontSize="inherit"
				/>
			);
	}
}
